import React, { useRef } from "react";
import connieImage from "./connie-contract-helper.png";
import connieAudio from "./connie-intro.mp3";
import HelpIcon from "@mui/icons-material/Help";
import {useLocation} from "react-router-dom";
import {Fade} from "@mui/material";

export default function ConnieContractHelper() {
    const audioRef = useRef(null);
    const [showConnie, setShowConnie] = React.useState(false);

    const { pathname } = useLocation();        // current URL path
    const isSplash = pathname === "/";         // change if your splash is a different route

    const handleShowConnie = async () => {


        try {
            if (audioRef.current && !showConnie) {
                audioRef.current.currentTime = 0;
                await audioRef.current.play();
            }
        } catch (err) {
            console.error("Audio play failed:", err);
        }
        setShowConnie(prev => !prev);
    };

    // useEffect(() => {
    //     if (audioRef.current) {
    //         audioRef.current.load();
    //     }
    // }, []);

    return (
        <div>
        {!isSplash &&
            (
                <Fade in timeout={2000}>
        <div>

            <HelpIcon sx={{mt: 1}} onClick={handleShowConnie} />

            <audio ref={audioRef} preload="auto" src={connieAudio}   />

            {showConnie && (
                <div
                    onClick={handleShowConnie}
                    style={{
                        position: "fixed",
                        // right: "20px",
                        // bottom: "20px",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 9999,
                        backgroundColor: "transparent",
                        cursor:'pointer'
                    }}
                >
                    <img
                        src={connieImage}
                        alt="Connie"
                        style={{
                            width: 360,
                            height: "auto"
                        }}
                    />
                </div>
            )}

        </div>
                </Fade>
            )}
    </div>
    );
}

// import React, {useEffect, useRef} from "react";
// import connieImage from "./connie-contract-helper.png";
// import connieAudio from "./connie-intro.mp3";
// import HelpIcon from "@mui/icons-material/Help";
//
// export default function ConnieContractHelper() {
//     const audioRef = useRef(null);
//     const [showConnie, setShowConnie] = React.useState(false);
//
//     const playConnie = () => {
//         audioRef.current?.play();
//     };
//
//     const handleShowConnie = () => {
//         setShowConnie(!showConnie);
//         audioRef.current?.play();
//     };
//
//     // useEffect(() => {
//     //     if (showConnie) {
//     //         playConnie();
//     //     }
//     // }, [showConnie]);
//
//     return (
//         <div>
//             <HelpIcon onClick={handleShowConnie} />
//             <audio ref={audioRef} preload="auto" src={connieAudio} />
//             {showConnie && (
//                 <div
//                     style={{
//                         position: "fixed",
//                         right: "20px",
//                         bottom: "20px",
//                         zIndex: 9999
//                     }}
//                 >
//                     <img
//                         src={connieImage}
//                         alt="Connie"
//                         style={{
//                             width: 360,
//                             height: "auto"
//                         }}
//                     />
//                 </div>
//             )}
//         {/*    {showConnie &&*/}
//         {/*<div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 12 }}>*/}
//         {/*    <img*/}
//         {/*        src={connieImage}*/}
//         {/*        alt="Connie Contract Helper"*/}
//         {/*        style={{ width: 360, maxWidth: "100%", height: "auto" }}*/}
//         {/*    />*/}
//
//         {/*    <audio ref={audioRef} preload="auto" src={connieAudio} />*/}
//
//         {/*    /!*<button type="button" onClick={playConnie}>*!/*/}
//         {/*    /!*    Play Connie*!/*/}
//         {/*    /!*</button>*!/*/}
//         {/*</div>*/}
//         {/*    }*/}
//         </div>
//
//     );
// }
